import { Card } from "@components/ui-kit";
import { BrandDetails } from "./BrandDetails";
import { InvoiceDetails } from "./InvoiceDetails";
import { InvoiceItems } from "./InvoiceItems";

export const MainCard = () => {
  return (
    <Card>
      <Card.Section>
        <div className="flex divide-x">
          <div className="w-1/2 pr-8">
            <BrandDetails />
          </div>
          <div className="w-1/2 pl-8">
            <InvoiceDetails />
          </div>
        </div>
      </Card.Section>
      <Card.Section>
        <InvoiceItems />
      </Card.Section>
    </Card>
  );
};
